import { HttpEvent } from '@angular/common/http';
import { Component, ElementRef, EventEmitter, Injector, Input, OnInit, Output, Renderer2, ViewChild, ViewEncapsulation } from '@angular/core';
import { AuthGuard } from '@app/shared/common/IDSVRAuthProviders/auth.guard.service';
import { FileUploaderComponent } from '@app/shared/common/file-uploader/file-uploader.component';
import { FileUploadResponse } from '@app/shared/common/file-uploader/models/file-upload-response';
import { StorageStrategies } from '@app/shared/common/file-uploader/service/file-storage.service';
import { MyFinancialService } from '@app/shared/services/my-financial.service';
import { AppComponentBase } from '@shared/common/app-component-base';
import { UploadServiceProxy } from '@shared/service-proxies/service-proxies';
import { BsModalRef } from 'ngx-bootstrap';
import { Observable, Subject } from 'rxjs';

@Component({
    selector: 'saving-upload-modal',
    templateUrl: './saving-upload-modal.component.html',
    styleUrls: ['./saving-upload-modal.component.css'],
    encapsulation: ViewEncapsulation.None
})
export class SavingUploadModalComponent extends AppComponentBase implements OnInit {
    @ViewChild('fileUploader') fileUploader: FileUploaderComponent;
    @Output() onUploadComplete: EventEmitter<boolean> = new EventEmitter<boolean>();
    storageStrategy: StorageStrategies;
    amount: number | undefined;
    selectedFile: File;
    isLoading: boolean;
    constructor(
        injector: Injector,
        private uploadService: UploadServiceProxy
    ) {
        super(injector);
    }

    ngOnInit() {
    }

    fileSelected(event: File) {
        this.selectedFile = event;
    }

    onUploadFinished(uploadResponse: any) {
        this.onUploadComplete.next(true);
    }
}
